export default "__VITE_ASSET__Btt2VtdY__"